import { Module } from 'vuex';

import { AutoUserCourseInfo, RootState, UserCoursesState } from 'frontend/types';

const userCourses: Module<UserCoursesState, RootState> = {
  namespaced: true,
  state: () => ({
    special_nux_user_category: null,
    special_nux_user_featured_courses: [],
    user_category: null,
    user_featured_courses: [],
  }),
  getters: {
    /** Get NUX recommended category/courses if they exist, else get default category/courses */
    userCourses(state): AutoUserCourseInfo {
      if (state.special_nux_user_category && state.special_nux_user_featured_courses.length) {
        return {
          category: state.special_nux_user_category,
          courses: state.special_nux_user_featured_courses,
          isSpecialNuxCategory: true,
        };
      }
      return {
        category: state.user_category,
        courses: state.user_featured_courses,
      };
    },
  },
  mutations: {
    setValue(state: UserCoursesState, value: UserCoursesState): void {
      Object.assign(state, value);
    },
  },
};

export default userCourses;
